import { useEffect, useState } from 'react';

interface ThisProps {
  aktuell: number,
  max: number
}

const MaxInputAnzahlComponent: React.FC<ThisProps> = (props) => {

  useEffect(() => {
  }, []);

  return (
    <>
      <div style={{textAlign: "end"}}>
        Anzahl {props.aktuell} / {props.max}
      </div>
    </>
  );
}

export default MaxInputAnzahlComponent;
